import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useParams } from 'react-router';
import { Header, Icon, Form } from 'semantic-ui-react';
import { useAgeReadyContext } from '../../AgeReadyContext/AgeReadyContext';
import { IResource } from '../../Models/Resource';
import { trackPromise, usePromiseTracker } from 'react-promise-tracker';

interface HeaderDetailsProps {
    resource?: IResource;
}

const UpdateResources: React.FC<HeaderDetailsProps> = (props) => {
    const { resource } = props;
    const { partnerStore } = useAgeReadyContext();
    const { partnerId } = useParams<{ partnerId: string }>();
    const [isEditing, setIsEditing] = useState(false);
    const { promiseInProgress } = usePromiseTracker();

    if (!resource) {
        return null;
    }

    const onEditResourceClick = () => {
        setIsEditing(true)
    }
    const handleSetHeader = (e: any) => {
        resource.setHeader(e.target.value)
    }
    const handlesetDetails = (e: any) => {
        resource.setDetails(e.target.value)
    }
    const onUpdateResource = async () => {
        const existingPartner = partnerStore.partnersByIdMap.get(partnerId);

        if (existingPartner !== undefined) {
            await trackPromise(partnerStore.savePartner(existingPartner));
            setIsEditing(false)
        }
    };

    return (
        <>
            {!isEditing && <Header>
                <Icon name="pencil" size="tiny" corner="top left" onClick={onEditResourceClick} style={{ cursor: 'pointer' }} color="grey" />
                <Header.Content>
                    {resource.header}
                    <Header.Subheader>
                        {resource.description}
                    </Header.Subheader>
                </Header.Content>
            </Header>}
            {isEditing &&
                <Form>
                    <Form.Input onChange={handleSetHeader} placeholder="Resource Title" value={resource.header} label="Resource Title" />
                    <br />
                    <Form.Input onChange={handlesetDetails} placeholder='Resource Details' value={resource.description} label="Resource Details" />
                    <br />
                    <Form.Button
                        primary
                        onClick={onUpdateResource}
                        loading={promiseInProgress}>
                        Update Resource
                    </Form.Button>
                </Form>}
        </>
    );
};

export default observer(UpdateResources);
